import {Presenter} from '../../../../Support/with_presenter';
import {Snippet} from '../../../../Models/Snippet';
import {
    ErrorResponse,
    loadingResponse,
    NetworkRequestStatus,
    NetworkResult,
    SuccessResponse,
} from '../../../../Network/NetworkResult';
import {ReportData} from './CompareReportPresenter';
import * as Throttle from 'promise-parallel-throttle';
import {DownloadedIndoorWorkout} from '../../../../Models/DownloadedIndoorWorkout';
import {StrokesService} from '../../../../Network/StrokesService';

export class CompareReportContentPresenter implements Presenter {
    public reportDataResult: NetworkResult<ReportData> = loadingResponse('Fetching snippets...');

    constructor(private snippets: Snippet[], private strokesService: StrokesService) {}

    public async mount(): Promise<void> {
        await this.loadReportData(this.snippets);
    }

    public unmount(): void {
        /* Noop */
    }

    private async loadReportData(snippets: Snippet[]) {
        if (snippets.length === 0) {
            this.reportDataResult = {
                status: NetworkRequestStatus.Success,
                data: {
                    snippets: [],
                    downloadedIndoorWorkouts: [],
                },
            };
            return;
        }
        this.reportDataResult = loadingResponse(`Downloading workouts... 0/${snippets.length}`);
        const downloadedIndoorWorkoutResults = await Throttle.all(
            snippets.map((snippet) => () => this.strokesService.forWorkoutId(snippet.publicWorkout.id)),
            {
                maxInProgress: 5,
                failFast: false,
                progressCallback: (result) => {
                    this.reportDataResult = loadingResponse(
                        `Downloading workouts... ${result.amountDone}/${snippets.length}`,
                    );
                },
            },
        );
        //If all failed then we should return the first error
        if (downloadedIndoorWorkoutResults.every((result) => result.status === NetworkRequestStatus.Error)) {
            this.reportDataResult = downloadedIndoorWorkoutResults[0] as ErrorResponse;
            return;
        }
        //Get successful workouts = workouts that are not in error state or loading
        const downloadedIndoorWorkouts = downloadedIndoorWorkoutResults
            .filter(
                (result): result is SuccessResponse<DownloadedIndoorWorkout> =>
                    result.status === NetworkRequestStatus.Success,
            )
            .map((result) => result.data);

        this.reportDataResult = {
            status: NetworkRequestStatus.Success,
            data: {
                downloadedIndoorWorkouts,
                snippets: snippets,
            },
        };
    }
}
